// extracted by mini-css-extract-plugin
export default {"loadingFull":"LoadingFull_loadingFull__IuGbd","loadingFull__spiner":"LoadingFull_loadingFull__spiner__myWVQ","spin":"LoadingFull_spin__V7+sE"};